import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title-bar"
}
const _hoisted_2 = { class: "title-bar__buttons" }

import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TitleBar',
  props: {
    title: {}
  },
  setup(__props: any) {



const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})

return (_ctx: any,_cache: any) => {
  return (mounted.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createBlock(_Teleport, { to: ".bf-layout__buttons" }, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ])),
        _createElementVNode("h1", null, _toDisplayString(__props.title), 1),
        _renderSlot(_ctx.$slots, "measurements")
      ]))
    : _createCommentVNode("", true)
}
}

})